module.exports = __webpack_public_path__ + "b47f346d270d4720707f6896255f5352.png";